import * as React from 'react';
import { MeatballMenu } from 'ui/common/dropdown-menu/meatball-menu';
import { PromptConfirmationModal } from 'ui/common/prompt-confirmation/prompt-confirmation-modal';
import { MyCaseDraftsTranslation } from 'app/area/my-case-drafts/constants';
import styles from './case-drafts-table-meatball.scss';

interface CaseDraftsMeatballProps {
  draftId: number;
  onDelete: (draftId: number) => void;
  translation: MyCaseDraftsTranslation;
  portalTarget?: HTMLElement | null;
}

export const CaseDraftsMeatball = React.memo(({ draftId, onDelete, translation, portalTarget }: CaseDraftsMeatballProps) => {
  if (!draftId) {
    return null;
  }

  return (
    <MeatballMenu portalTarget={portalTarget} className={styles.meatball}>
      <PromptConfirmationModal
        title={translation.my_case_drafts_delete_title}
        description={translation.my_case_drafts_delete_description}
        continueText={translation.my_case_drafts_delete_continue}
        cancelText={translation.my_case_drafts_delete_cancel}
        onContinue={() => onDelete(draftId)}>
        <button type="button" className="dropdown-item">{translation.my_case_drafts_delete}</button>
      </PromptConfirmationModal>
    </MeatballMenu>
  );
});
